import { Component, Injector, OnInit } from '@angular/core';
import { BaseComponent } from 'src/app/shared/baseComponent';

@Component({
  selector: 'app-organizations',
  templateUrl: './organizations.component.html',
  styleUrls: ['./organizations.component.css']
})
export class OrganizationsComponent extends BaseComponent implements OnInit {
  organizations: any = [];
  organization: any = { id: 0, name: "" };
  sortArray: any = []
  
  constructor(injector: Injector) { super(injector) }

  async ngOnInit() {
    this.loader.show()
    await this.getData()
    this.loader.hide()
  }

  async getData() {
    this.organizations = await this.db.get("Organization", "getOrganizations")
  }

  selectOrg(org: any) {
    this.organization = org;
  }
  
  async submit() {
    this.loader.show();
    const resp = await this.db.post("organization", "postorganization", this.organization);
    await this.getData();
    this.loader.hide();
  }

  add() {
    this.organization = { id: 0, name: "" };
  }

  async delete(org: any) {
    this.loader.show();
    const resp = await this.db.delete("organization", "deleteorganization", { id: org.id });
    this.organization = {};
    await this.getData();
    this.loader.hide();
  }
}
